/* eslint-disable no-nested-ternary */
/* eslint-disable no-param-reassign */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable object-shorthand */
import { Box, Dialog, Slide, useMediaQuery } from "@mui/material";
import { MathJax } from "better-react-mathjax";
import React, { useEffect, useMemo, useState } from "react";
import { FormattedMessage } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { useRouter } from "next/router";
import dynamic from "next/dynamic";
import lodash from "lodash";
import { ERROR_CODE } from "../../../arena/utils/constants";
import { MISSION_VIEW_ADS_EXAM_SKU, OPENING_VIEW_TYPE_QUIZ_PDF } from "../../../../utils/constants/constants";
import { ResultBoard } from "./ResultBoard";
import GoogleAd from "../GoogleAd";
import { DisplayQuizPDF, PopupShowSolutionPDF } from "./DisplayQuizPDF";
import QuestionRow from "./QuestionRow";
import {
  quizAnswerType,
  QUIZ_TYPE_PRACTICE,
  TYPE_EXAM,
  getNativeOnScreen,
  NATIVE_SURVEY_TYPE,
  MAXIMUM_CORRECT_OPTION_CONSTRUCTED_RESPONSE_LENGTH
} from "../../utils/constant";
import { genSignature, getNonce, isEmpty } from "../../../../utils/helpers/helpers";
import { arenaRoomActions } from "../../../arena/redux/actions";
import { quizActions } from "../../../topics/redux/actions";
import AlertDialog from "../../dialog/AlertDialog";
import CongratulationAlertDialog from "../../dialog/CongratulationAlertDialog";
import AnswerBoard from "./AnswerBoard";
import ResultQuizDetail from "./ResultQuizDetail";
import GoogleAdDialog from "../../dialog/GoogleAdDialog";
import { commonActions } from "../../redux/actions";
import Breadcrumb from "../BreadCrumb";
import HeaderQuizResponsive from "./HeaderQuizResponsive";
import XCircle from "../../../../../public/assets/icons/XCircle";
import { TArenaState } from "../../../arena/utils/types";
import { eventTracking } from "../../../../firebase/firebaseConfig";
import { TCommonState } from "../../utils/type";
import QuestionParentRow from "./QuestionParentRow";

const Transition = React.forwardRef((props: any, ref: any) => {
  return (
    // eslint-disable-next-line react/no-children-prop
    <Slide children={props.children} direction="up" ref={ref} {...props} />
  );
});

const NativeSurvey = dynamic(() => import("../../../common/components/NativeSurvey"), {
  ssr: false
});

function QuizCoreView({
  quizDetail,
  progress,
  quizInfoStart,
  quizInfoSolutions,
  quizInfoSubmit,
  answerTotal,
  handleSaveAnswerTotal,
  startTime,
  endTime,
  isArena,
  dataList,
  continueFunction,
  redoFunction,
  notify,
  dataAnalysis,
  fetchUserInfos,
  cleanCongratulation,
  setLeavePageConfirm,
  setQuizInfoSolutions,
  congratulation,
  roomDetail
}: any) {
  const [openSubmitDialog, setOpenSubmitDialog] = useState(false);
  const [openAlertDialogTimeOut, setOpenAlertDialogTimeOut] = useState(false);
  const [openResultDialog, setOpenResultDialog] = useState(false);
  const [openGgAd, setOpenGgAd] = useState(false);
  // const [isShowContinueButton, setIsShowContinueButton] = useState(false);
  const [isDynamicMathJax, setIsDynamicMathJax] = useState(quizInfoSolutions?.results?.length > 1);
  const dispatch = useDispatch();
  const router = useRouter();
  const { diffTimeSeconds, survey } = useSelector((state: { commonNew: TCommonState }) => state.commonNew);

  const [openAlertDialogVipRequire, setOpenAlertDialogVipRequire] = useState(false);
  const [openAlertDialogGuide, setOpenAlertDialogGuide] = useState(false);
  const [openSolutionPDF, setOpenSolutionPDF] = useState(false);
  const [dataSolution, setDataSolution] = useState({});
  const [showSolutionAfterViewAds, setShowSolutionAfterViewAds] = useState(false);
  const matches1100 = useMediaQuery("(min-width:1100px)");
  const matches768 = useMediaQuery("(min-width:768px)");
  const [isRedoPDF, setIsRedoPDF] = useState(false);

  const nativeSurveys = useMemo(() => {
    return getNativeOnScreen(survey, router?.pathname, router) || [];
  }, [survey, router]);

  const arrayQuizData = isArena ? quizDetail?.items?.filter((e) => e?.answer_type !== quizAnswerType.NONE) : dataList;
  const isShowContinueButton =
    (quizDetail?.subject?.type === QUIZ_TYPE_PRACTICE &&
      progress?.finished_quiz <
        quizDetail?.items?.filter((ele: { answer_type: number }) => ele.answer_type !== quizAnswerType.NONE).length) ||
    (!isEmpty(progress) && progress?.length < quizDetail?.quiz_question_groups?.length);

  const showSolutionPDF = (questionId: any, indexQuestion: any) => {
    const solution = quizInfoSolutions?.solutions.find(
      (e: { quiz_question_id: any }) => e.quiz_question_id === questionId
    )?.items?.detail;
    if (!solution) return;
    solution.index = indexQuestion;
    setDataSolution(solution);
    if (quizInfoSolutions?.is_show_solution || showSolutionAfterViewAds) {
      setOpenSolutionPDF(true);
    } else {
      setOpenAlertDialogVipRequire(true);
    }
  };

  // chọn đáp án với type là ONE_ANSWER
  const chooseAnswerOfOneAnswerQuestion = (selectionsId: number, questionId: number) => {
    setIsDynamicMathJax(false);
    if (progress) return;
    const indexAsw = answerTotal?.findIndex((v: { question_id: any }) => v.question_id === questionId);
    const indexAswDetail = answerTotal?.findIndex(
      (v: { question_id: any; selections: any[] }) => v.question_id === questionId && v?.selections[0] === selectionsId
    );
    const tempAnswerTotal = answerTotal;
    if (indexAswDetail > -1) {
      tempAnswerTotal?.splice(indexAswDetail, 1);
    } else {
      if (indexAsw > -1) {
        tempAnswerTotal?.splice(indexAsw, 1);
      }
      tempAnswerTotal?.push({
        question_id: questionId,
        selections: [selectionsId]
      });
    }
    handleSaveAnswerTotal(tempAnswerTotal);
  };
  // chọn đáp án với type là MANY_ANSWER
  const chooseAnswerOfManyAnswerQuestion = (selectionId: number, questionId: number) => {
    setIsDynamicMathJax(false);
    if (progress) return;
    const answer = answerTotal?.find((v: { question_id: any }) => v.question_id === questionId);

    let clonedAnswerTotal = [...answerTotal];

    if (!answer) {
      clonedAnswerTotal?.push({
        question_id: questionId,
        selections: [selectionId]
      });
    } else {
      const indexSelection = answer.selections.findIndex((selection) => selection === selectionId);
      if (indexSelection > -1) {
        clonedAnswerTotal = clonedAnswerTotal.map((clonedAnswer) => {
          if (clonedAnswer.question_id === questionId) {
            clonedAnswer.selections.splice(indexSelection, 1);
          }
          return clonedAnswer;
        });
      } else {
        clonedAnswerTotal = clonedAnswerTotal.map((clonedAnswer) => {
          if (clonedAnswer.question_id === questionId) {
            clonedAnswer.selections.push(selectionId);
          }
          return clonedAnswer;
        });
      }
    }
    handleSaveAnswerTotal(clonedAnswerTotal);
  };
  // chọn đáp án với type là sort position
  const addDataToStateSortPosition = (arraySelectionData: any[], questionId: number) => {
    const indexAsw = answerTotal?.findIndex((v: { question_id: any }) => v.question_id === questionId);
    const tempAnswerTotalSortPosition = answerTotal;
    const selections: string[] = [];
    if (arraySelectionData.length > 0) {
      const qsOptions = arrayQuizData?.find(
        (e: { id: number; answer_type: number }) =>
          e.id === questionId && e.answer_type === quizAnswerType.SORT_POSITION
      )?.options;
      arraySelectionData.forEach((element: any) => {
        selections.push(qsOptions.find((_: any, ix: number) => ix + 1 === element)?.id);
      });
    }
    const tempData = {
      question_id: questionId,
      selections: selections,
      arrayIndex: arraySelectionData
    };
    if (indexAsw > -1) {
      tempAnswerTotalSortPosition[indexAsw] = tempData;
    } else {
      tempAnswerTotalSortPosition.push(tempData);
    }
    handleSaveAnswerTotal(tempAnswerTotalSortPosition);
  };

  // chọn đáp án với type là WORD, LETTER
  const addDataToState = (arraySelectionData: any[], questionId: number) => {
    const indexAsw = answerTotal.findIndex((v: { question_id: any }) => v.question_id === questionId);
    const tempAnswerTotal = answerTotal;
    let tempDataAnswer = {};
    if (Array.isArray(arraySelectionData[0])) {
      // chọn chữ thành từ > 2
      tempDataAnswer = {
        question_id: questionId,
        selections: arraySelectionData
      };
    } else if (arraySelectionData?.some((ele: string | any[]) => ele?.length > 1)) {
      // chọn từ thành câu
      tempDataAnswer = {
        question_id: questionId,
        selections: arraySelectionData
      };
      // 2 case trên giống nhau nhưng tách ra để dễ debug và mở rộng sau này
    } else {
      // chọn chữ thành từ
      tempDataAnswer = {
        question_id: questionId,
        selections: [arraySelectionData.join("")]
      };
    }
    if (indexAsw > -1) {
      tempAnswerTotal[indexAsw] = tempDataAnswer;
    } else {
      tempAnswerTotal.push(tempDataAnswer);
    }
    handleSaveAnswerTotal(tempAnswerTotal);
  };

  // Chọn đáp án với type là CONSTRUCTED_RESPONSE
  const handleChangeAnswerConstructedResponse = (answerContent: string, questionId: number) => {
    const answerIndex = answerTotal.findIndex((v: { question_id: any }) => v.question_id === questionId);
    const clonedAnswerTotal = answerTotal;

    if (answerIndex === -1) {
      if (!answerContent.trim()) {
        return;
      }
      clonedAnswerTotal?.push({
        question_id: questionId,
        selections: [answerContent]
      });
    } else if (answerContent.trim()) {
      clonedAnswerTotal[answerIndex] = {
        question_id: questionId,
        selections: [answerContent]
      };
    } else {
      clonedAnswerTotal.splice(answerIndex, 1);
    }

    handleSaveAnswerTotal(clonedAnswerTotal);
  };
  const checkCountResult = (answerTotalData: any[]) => {
    const tempData = answerTotalData?.map((element: { selections: any[]; question_id: any }) => {
      if (element?.selections.length === 1) {
        const tempDataPractice = quizDetail?.items?.find((ele: { id: any }) => ele?.id === element?.question_id);
        if (
          !tempDataPractice ||
          tempDataPractice?.answer_type === quizAnswerType.ONE_ANSWER ||
          tempDataPractice?.answer_type === quizAnswerType.MANY_ANSWER ||
          tempDataPractice?.answer_type === quizAnswerType.CONSTRUCTED_RESPONSE
        )
          return true;
        return (
          JSON.parse(tempDataPractice?.options[0]?.items[0]?.content || "{}")?.selections[0] ===
          element?.selections[0]?.length
        );
      }
      const tempDataFlat = element.selections.flat();
      return tempDataFlat.length === tempDataFlat?.filter((ele: any) => ele)?.length;
    });
    return tempData?.filter((ele: any) => ele)?.length || 0;
  };

  const getDataAnswerTotal = () => {
    const dataAnswerTotal = answerTotal;
    return dataAnswerTotal.map((element: { arrayIndex: any; selections: any[]; question_id: any }) => {
      if (element?.arrayIndex) {
        delete element.arrayIndex;
      }
      const finalSelections = element?.selections?.filter((e) => !!e);
      const tempData = quizDetail?.items.find((ele: { id: any }) => ele.id === element?.question_id);
      if (finalSelections.length > 1) {
        if (Array.isArray(finalSelections[0])) {
          return {
            ...element,
            selections: finalSelections?.flat()?.filter((e) => !!e) || []
          };
        }
        if (tempData.answer_type === quizAnswerType.SORT_POSITION) {
          return {
            question_id: element.question_id,
            selections: !(finalSelections?.findIndex((e: null) => e === null) > -1) ? finalSelections : []
          };
        }
        if (tempData.answer_type === quizAnswerType.CONCAT_WORD) {
          return {
            ...element,
            selections: finalSelections || []
          };
        }
        if (tempData.answer_type === quizAnswerType.MANY_ANSWER) {
          return {
            ...element,
            selections: finalSelections || []
          };
        }
        return {
          ...element,
          selections: [finalSelections?.join("")] || []
        };
      }
      if (tempData.answer_type === quizAnswerType.CONSTRUCTED_RESPONSE) {
        return {
          question_id: element.question_id,
          selections: [finalSelections?.[0]?.slice(0, MAXIMUM_CORRECT_OPTION_CONSTRUCTED_RESPONSE_LENGTH)?.trim()] || []
        };
      }
      return {
        question_id: element.question_id,
        selections: finalSelections || []
      };
    });
  };
  const fetchQuizSubmit = async () => {
    const maxEndTime = moment(startTime).add(quizDetail?.time, "minutes").unix();
    const nowTimestamp = moment().subtract(diffTimeSeconds, "seconds").unix();
    const dataAnswerTotal = getDataAnswerTotal();
    const dataSubmitQuizPre = {
      answers: dataAnswerTotal,
      quiz_start_token: quizInfoStart?.quiz_start_token,
      start_time: isArena ? moment(startTime).unix() : moment(startTime).subtract(diffTimeSeconds, "seconds").unix(),
      // eslint-disable-next-line no-nested-ternary
      end_time: quizDetail?.time <= 0 ? nowTimestamp : nowTimestamp > maxEndTime ? maxEndTime : nowTimestamp,
      timestamp: nowTimestamp,
      nonce: getNonce()
    };
    const dataSubmitQuiz = {
      ...dataSubmitQuizPre,
      signature: genSignature(JSON.parse(JSON.stringify(dataSubmitQuizPre))),
      roomHid: roomDetail?.room_hid || router?.query?.roomHid
    };
    if (isArena) {
      eventTracking("select_are_exam_submit", {}, () => dispatch(arenaRoomActions.handleSubmitQuiz(dataSubmitQuiz)));
    } else {
      dispatch(quizActions.handleQuizSubmit({ ...dataSubmitQuiz, topicId: quizDetail.id }));
    }
  };

  const fetchPatchQuizStart = () => {
    const dataPatchQuizStartPre = {
      quiz_info_token: quizDetail?.quiz_info_token,
      quiz_start_token: quizInfoStart?.quiz_start_token,
      timestamp: moment().unix(),
      nonce: getNonce()
    };
    const dataPatchQuizStart = {
      ...dataPatchQuizStartPre,
      signature: genSignature(dataPatchQuizStartPre)
    };
    dispatch(arenaRoomActions.handlePatchQuizStart(dataPatchQuizStart));
  };
  const missionViewAdsExam = () => {
    const dataPostPre = {
      sku: MISSION_VIEW_ADS_EXAM_SKU,
      timestamp: moment().unix(),
      nonce: getNonce()
    };
    const dataPost = {
      ...dataPostPre,
      signature: genSignature(dataPostPre)
    };
    dispatch(commonActions.handleCompleteMission(dataPost));
  };
  const scrollFunc = (id: string) =>
    document.getElementById(id)?.scrollIntoView({
      behavior: "smooth",
      block: "center"
    });

  const idQuestion = useSelector((state: { arenaRoom: TArenaState }) => state.arenaRoom.questionIdScroll);

  const listParentIdShowGroup = useMemo(() => {
    // check câu parent có nhiều hơn 1 child
    const checkParentAvailable = (parentId) => quizDetail?.items?.filter((e) => e?.parent === parentId).length > 1;

    return quizDetail?.items
      ?.filter((ele) => ele?.answer_type === quizAnswerType.NONE && checkParentAvailable(ele?.id))
      ?.map((e) => e?.id);
  }, [quizDetail?.items]);
  const isFirstChildGroup = (parentId) => {
    return lodash.orderBy(quizDetail?.items?.filter((e) => e?.parent === parentId)?.map((e) => e?.id))[0];
  };
  const isParentGroup = (parentId) => parentId && listParentIdShowGroup?.includes(parentId);

  useEffect(() => {
    scrollFunc(idQuestion);
  }, [idQuestion, notify]);

  useEffect(() => {
    // submit mà quiz_start_token hết hạn thì call PatchQuizStart lấy lại quiz_start_token và submit lại
    if (notify?.type === "SUBMIT_QUIZ_FAILED" && notify?.errorCode === ERROR_CODE.TOKEN_QUIZ_EXPIRED_INTERNAL) {
      fetchPatchQuizStart();
      fetchQuizSubmit();
    }
  }, [notify]);
  const numOfPractice =
    quizDetail?.subject?.type === TYPE_EXAM
      ? quizDetail?.items.filter((e: { answer_type: number }) => e.answer_type !== quizAnswerType.NONE).length
      : quizDetail?.count;
  const quizOpeningViewTypePDF = quizDetail?.opening_view_type === OPENING_VIEW_TYPE_QUIZ_PDF;
  useEffect(() => {
    if (progress && quizDetail?.opening_view_type === OPENING_VIEW_TYPE_QUIZ_PDF) {
      setOpenAlertDialogGuide(true);
      eventTracking("view_quiz_result");
    }
  }, [progress]);

  useEffect(() => {
    dispatch(
      commonActions.handleHideDialogSurvey(
        openGgAd || openAlertDialogTimeOut || openAlertDialogVipRequire || openSolutionPDF || openSubmitDialog
      )
    );
  }, [openGgAd, openAlertDialogTimeOut, openAlertDialogVipRequire, openSolutionPDF, openSubmitDialog]);

  if (isEmpty(arrayQuizData)) return null;
  return (
    <>
      {!matches768 && (
        <HeaderQuizResponsive
          progress={progress}
          quizInfoStart={quizInfoStart}
          setOpenSubmitDialog={setOpenSubmitDialog}
          checkCountResult={checkCountResult}
          answerTotal={answerTotal}
          isShowContinueButton={isShowContinueButton}
          startTime={startTime}
          endTime={endTime}
          continueFunction={continueFunction}
          redoFunction={() => {
            redoFunction();
            setIsRedoPDF(true);
          }}
          setOpenAlertDialogTimeOut={setOpenAlertDialogTimeOut}
          setOpenResultDialog={setOpenResultDialog}
          quizDetail={quizDetail}
          arrayQuizData={arrayQuizData}
          chooseAnswerOfOneAnswerQuestion={chooseAnswerOfOneAnswerQuestion}
          chooseAnswerOfManyAnswerQuestion={chooseAnswerOfManyAnswerQuestion}
          isArena={isArena}
        />
      )}
      <Box display="flex" justifyContent="space-between">
        {matches768 && (
          <div>
            {(progress || !matches1100) && (
              <Box
                style={{
                  display: "flex",
                  flexDirection: "column"
                }}
                className="md:mr-[32px] lg:mr-[48px]"
              >
                <Box width={matches1100 ? 330 : 282} className="absolute top-[-30px] truncate">
                  <Breadcrumb />
                </Box>
                <div className="md:w-[250px] lg:w-[298px]">
                  {!matches1100 && !progress && (
                    <AnswerBoard
                      checkCountResult={checkCountResult}
                      quizInfoStart={quizInfoStart}
                      answerTotal={answerTotal}
                      startTime={startTime}
                      endTime={endTime}
                      isArena={isArena}
                      quizDetail={quizDetail}
                      setOpenAlertDialogTimeOut={setOpenAlertDialogTimeOut}
                      arrayQuizData={arrayQuizData}
                      chooseAnswerOfOneAnswerQuestion={chooseAnswerOfOneAnswerQuestion}
                      setOpenSubmitDialog={setOpenSubmitDialog}
                      scrollFunc={scrollFunc}
                    />
                  )}
                  {!matches1100 && progress && (
                    <ResultBoard
                      key="result-board-key"
                      quizInfoSolutions={quizInfoSolutions}
                      quizOpeningViewTypePDF={quizOpeningViewTypePDF}
                      scrollFunc={scrollFunc}
                      showSolutionPDF={showSolutionPDF}
                      dataList={arrayQuizData}
                    />
                  )}
                  {progress && (
                    <ResultQuizDetail
                      progress={progress}
                      quizInfoSubmit={quizInfoSubmit}
                      subjectName={quizDetail?.subject_type?.title}
                      setOpenGgAd={setOpenGgAd}
                      redoFunc={() => {
                        redoFunction();
                        setIsRedoPDF(true);
                        window.scrollTo(0, 0);
                      }}
                      isShowContinueButton={isShowContinueButton}
                      continueFunction={continueFunction}
                      openAlertDialogTimeOut={openAlertDialogTimeOut}
                      numOfPractice={numOfPractice}
                      isArena={isArena}
                      dataAnalysis={dataAnalysis}
                    />
                  )}
                  {/* <div className="max-h-[226px] z-[1] flex justify-center my-2 mt-4" id="googleAds">
                    <GoogleAd
                      style={{
                        display: "block",
                        height: 226,
                        width: !matches1100 ? 250 : 298
                      }}
                      slot={process.env.NEXT_PUBLIC_GOOGLE_AD_SLOT_ARTICLE}
                    />
                  </div>
                  */}
                </div>
              </Box>
            )}
          </div>
        )}
        <Box sx={{ display: "flex", flexDirection: "column", width: "100%", marginRight: matches1100 ? "48px" : 0 }}>
          <NativeSurvey
            currentSurvey={nativeSurveys?.find((e) => e?.location_survey?.native === NATIVE_SURVEY_TYPE.TOP)}
          />
          <Box
            sx={{ borderRadius: "6px", padding: !matches1100 ? "16px 8px" : "24px 16px", background: "white", my: 2 }}
          >
            <Box
              display="flex"
              justifyContent="space-between"
              className="md:w-full sm:w-screen overflow-x-hidden scrollbar-hide"
            >
              <span className="sm:mr-2 md:mr-0 text-[20px] font-bold" style={{ textAlign: "justify", width: "100%" }}>
                {quizDetail?.title}
              </span>
            </Box>
            {quizDetail?.opening_view_type === OPENING_VIEW_TYPE_QUIZ_PDF ? (
              <DisplayQuizPDF file={quizDetail?.questions[0]?.content} isRedo={isRedoPDF} />
            ) : (
              <Box mt={3} display="flex" flexDirection="column">
                <MathJax dynamic={isDynamicMathJax} inline>
                  <Box>
                    {arrayQuizData?.map((element: any, index: number) => {
                      return (
                        <div key={element.id}>
                          <hr
                            className={`${isParentGroup(element?.parent) && 'mx-8'}`}
                            style={{
                              opacity: "20%",
                              display: index > 0 ? "block" : "none",
                            }}
                          />
                          {index === Math.ceil(arrayQuizData?.length / 2) && (
                            <div className="lg:mx-[-16px] sm:mx-[-8px]">
                              <NativeSurvey
                                currentSurvey={nativeSurveys?.find(
                                  (e) => e?.location_survey?.native === NATIVE_SURVEY_TYPE.CENTER
                                )}
                              />
                            </div>
                          )}
                          {isParentGroup(element?.parent) && isFirstChildGroup(element?.parent) === element?.id && (
                            <QuestionParentRow element={quizDetail?.items?.find((e) => e?.id === element?.parent)} />
                          )}
                          <QuestionRow
                            element={element}
                            index={index}
                            practice={quizDetail}
                            answerTotalQuestion={answerTotal?.find((e) => e.question_id === element.id)}
                            quizInfoSolutions={quizInfoSolutions}
                            chooseAnswerOfOneAnswerQuestion={chooseAnswerOfOneAnswerQuestion}
                            chooseAnswerOfManyAnswerQuestion={chooseAnswerOfManyAnswerQuestion}
                            addDataToState={addDataToState}
                            setQuizInfoSolutions={setQuizInfoSolutions}
                            addDataToStateSortPosition={addDataToStateSortPosition}
                            onChangeAnswerConstructedResponse={handleChangeAnswerConstructedResponse}
                            setIsDynamicMathJax={setIsDynamicMathJax}
                            isArena={isArena}
                            isParentGroup={isParentGroup(element?.parent)}
                          />
                        </div>
                      );
                    })}
                  </Box>
                </MathJax>
              </Box>
            )}
          </Box>
          <NativeSurvey
            currentSurvey={nativeSurveys?.find((e) => e?.location_survey?.native === NATIVE_SURVEY_TYPE.BOTTOM)}
          />
        </Box>
        {matches1100 && (
          <Box>
            <Box
              style={{
                display: "flex",
                flexDirection: "column",
                minHeight: 120,
                position: "sticky"
                // top: 20
              }}
            >
              {!progress ? (
                <AnswerBoard
                  checkCountResult={checkCountResult}
                  quizInfoStart={quizInfoStart}
                  answerTotal={answerTotal}
                  startTime={startTime}
                  endTime={endTime}
                  isArena={isArena}
                  quizDetail={quizDetail}
                  setOpenAlertDialogTimeOut={setOpenAlertDialogTimeOut}
                  arrayQuizData={arrayQuizData}
                  chooseAnswerOfOneAnswerQuestion={chooseAnswerOfOneAnswerQuestion}
                  chooseAnswerOfManyAnswerQuestion={chooseAnswerOfManyAnswerQuestion}
                  setOpenSubmitDialog={setOpenSubmitDialog}
                  setLeavePageConfirm={setLeavePageConfirm}
                  scrollFunc={scrollFunc}
                />
              ) : (
                <ResultBoard
                  key="result-board-key"
                  quizInfoSolutions={quizInfoSolutions}
                  scrollFunc={scrollFunc}
                  showSolutionPDF={showSolutionPDF}
                  dataList={arrayQuizData}
                  quizOpeningViewTypePDF={quizOpeningViewTypePDF}
                />
              )}
            </Box>
            <div className="w-[298px] h-[720px] mt-3" id="googleAdsRight">
              <GoogleAd
                style={{
                  display: "block",
                  height: 720,
                  width: 298
                }}
                slot={process.env.NEXT_PUBLIC_GOOGLE_AD_SLOT_ARTICLE}
              />
            </div>
          </Box>
        )}
        {!isArena && !isEmpty(congratulation?.success_message) && (
          <CongratulationAlertDialog
            data={congratulation}
            openDialog={!isEmpty(congratulation?.success_message)}
            handleCloseDialog={cleanCongratulation}
            triggerFunc={fetchUserInfos}
          />
        )}
        {openSubmitDialog && (
          <AlertDialog
            title={<FormattedMessage id="DialogInfo.title" />}
            open={openSubmitDialog}
            setOpen={setOpenSubmitDialog}
            triggerFunc={() => {
              fetchQuizSubmit();
              setLeavePageConfirm();
            }}
            styleContent={{ width: "100%", textAlign: "center" }}
            content={
              <span style={{ width: "100%", textAlign: "center" }}>
                <FormattedMessage id="quiz.submitMessage" />
              </span>
            }
            buttonOkKey="Question.submit"
          />
        )}
        {openAlertDialogTimeOut && (
          <AlertDialog
            open={openAlertDialogTimeOut}
            setOpen={setOpenAlertDialogTimeOut}
            title={<FormattedMessage id="Setting.notification" />}
            content={<FormattedMessage id="quiz.timeCompleteDialog" />}
            triggerFunc={() => {
              fetchQuizSubmit();
              setLeavePageConfirm(false);
            }}
            isHideCancel
            isDisabledHandleClose
            buttonOkKey="common.ok"
          />
        )}
      </Box>
      {quizOpeningViewTypePDF && (
        <>
          {dataSolution && openSolutionPDF && matches768 && (
            <PopupShowSolutionPDF open={openSolutionPDF} setOpen={setOpenSolutionPDF} data={dataSolution} />
          )}
          {openAlertDialogGuide && (
            <AlertDialog
              open={openAlertDialogGuide}
              setOpen={setOpenAlertDialogGuide}
              title={<FormattedMessage id="common.guide" />}
              content={<FormattedMessage id="ExamQuestion.solutionGuidDialog" />}
              contentKey="common.note"
              triggerFunc={() => {}}
              styleContent={{ textAlign: "center", width: "100%" }}
              buttonOkKey="common.ok"
              isHideCancel
            />
          )}
        </>
      )}
      {openGgAd && (
        <GoogleAdDialog
          open={openGgAd}
          setOpen={setOpenGgAd}
          triggerFunc={() => {
            if (showSolutionAfterViewAds) {
              setOpenSolutionPDF(true);
            } else {
              missionViewAdsExam();
            }
          }}
        />
      )}
      {openAlertDialogVipRequire && (
        <AlertDialog
          open={openAlertDialogVipRequire}
          setOpen={setOpenAlertDialogVipRequire}
          title="Thông báo"
          content={<FormattedMessage id="ExamQuestion.solutionTitle" />}
          triggerFunc={() => {
            setOpenGgAd(true);
            setShowSolutionAfterViewAds(true);
            eventTracking("select_ic_play_video");
          }}
          contentKey="common.note"
          styleContent={{ textAlign: "center", width: "100%" }}
          buttonOkKey="IDS_View_Ads"
        />
      )}

      {!matches768 && openResultDialog && (
        <Dialog fullScreen open={openResultDialog} TransitionComponent={Transition}>
          <button
            type="button"
            onClick={() => setOpenResultDialog(false)}
            style={{
              position: "absolute",
              right: 4,
              top: 4,
              background: "white"
            }}
          >
            <XCircle />
          </button>
          <div className="mt-4 pb-3">
            <ResultBoard
              key="result-board-key"
              quizInfoSolutions={quizInfoSolutions}
              quizOpeningViewTypePDF={quizOpeningViewTypePDF}
              scrollFunc={() => {}}
              showSolutionPDF={showSolutionPDF}
              dataList={arrayQuizData}
              isDialog
            />
            <ResultQuizDetail
              progress={progress}
              quizInfoSubmit={quizInfoSubmit}
              subjectName={quizDetail?.subject_type?.title}
              setOpenGgAd={setOpenGgAd}
              redoFunc={() => {
                redoFunction();
                setIsRedoPDF(true);
                window.scrollTo(0, 0);
              }}
              isShowContinueButton={isShowContinueButton}
              continueFunction={continueFunction}
              openAlertDialogTimeOut={openAlertDialogTimeOut}
              numOfPractice={numOfPractice}
              isArena={isArena}
              dataAnalysis={dataAnalysis}
              isDialog
            />
            {dataSolution && openSolutionPDF && (
              <PopupShowSolutionPDF open={openSolutionPDF} setOpen={setOpenSolutionPDF} data={dataSolution} />
            )}
          </div>
        </Dialog>
      )}
    </>
  );
}
export default QuizCoreView;
